import createVueComponent from '../createVueComponent';
export default createVueComponent('outline', 'brand-supabase', 'IconBrandSupabase', [["path",{"d":"M4 14h8v7l8 -11h-8v-7z","key":"svg-0"}]]);